import { render, staticRenderFns } from "./MainQuestions.vue?vue&type=template&id=d156178e&scoped=true&"
import script from "./MainQuestions.vue?vue&type=script&lang=js&"
export * from "./MainQuestions.vue?vue&type=script&lang=js&"
import style0 from "./MainQuestions.vue?vue&type=style&index=0&id=d156178e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d156178e",
  null
  
)

export default component.exports